import { Button, Glyph } from "@motleyhand/design"
import { toast } from "sonner"
import { AppLogo } from "@/ui"

export default function TmpPage() {
  return (
    <div className="space-y-4 p-10">
      <div className="w-full p-10">
        <AppLogo size={24} className="m-8" />
        <AppLogo size={32} className="m-8" />
        <AppLogo size={48} className="m-8" />
        <AppLogo size={60} className="m-8" />
        <Glyph variant="diamond" size={30} className="m-8" />
        <Glyph variant="tricolor" size={30} className="m-8" />
        <Glyph variant="balls" size={30} className="m-8" />
        <Glyph variant="balls-arc" size={30} className="m-8" />
        <Glyph variant="staggered-bars" size={30} className="m-8" />
        <Glyph variant="corner-cluster" size={30} className="m-8" />
        <Glyph variant="corner-scatter" size={30} className="m-8" />
        <Glyph variant="divider-spread" size={30} className="m-8" />
        <Glyph variant="burst-toss" size={30} className="m-8" />
        <Glyph variant="dropped-catch" size={30} className="m-8" />
      </div>
      <div className="flex flex-wrap gap-2">
        <Button
          variant="outline"
          onClick={() => toast("Event has been created")}
        >
          Default
        </Button>
        <Button
          variant="outline"
          onClick={() => toast.success("Event has been created")}
        >
          Success
        </Button>
        <Button
          variant="outline"
          onClick={() =>
            toast.info("Be at the area 10 minutes before the event time")
          }
        >
          Info
        </Button>
        <Button
          variant="outline"
          onClick={() =>
            toast.warning("Event start time cannot be earlier than 8am")
          }
        >
          Warning
        </Button>
        <Button
          variant="outline"
          onClick={() => toast.error("Event has not been created")}
        >
          Error
        </Button>
        <Button
          variant="outline"
          onClick={() => {
            toast.promise<{ name: string }>(
              () =>
                new Promise((resolve) =>
                  setTimeout(() => {
                    resolve({ name: "Event" })
                  }, 2000),
                ),
              {
                loading: "Loading...",
                success: (data) => `${data.name} has been created`,
                error: "Error",
              },
            )
          }}
        >
          Promise
        </Button>
      </div>
    </div>
  )
}
